import Element from '../../../Prototype/UI/Element';
import Game from '../../../Game';
import { IGameState } from '../../../State/Game/IGameState';
import GameObject, { GameObjectEvent } from '../../../GameObject/GameObject';
import AnimationComponent from '../../../Component/Animation';
import ButtonComponent from '../../../Component/UI/ButtonComponent';
import { applyDefaultButtonAnimation } from '../../../System/UI/UIHelper';
import UITextComponent from '../../../Component/UI/Text';
import SundayOfferTimer from '../../../System/Timer/Timers/SundayOfferTimer';
import Renderable from '../../../Component/Renderable';
import { UIActions } from '../../../State/UI/UIActions';
import StateComponent from '../../../Component/State';
import { PopupID } from '../../../State/UI/PopupID';
import { IAPHelper } from 'Utility/Helpers/IAP/IAPHelper';
import { IAPStateHelper } from 'State/Player/IAP/IAPStateHelper';

export default class SundayOfferButton extends Element {
    public static BUTTON_NAME: string = 'sunday_offer_btn';
    public static TIMER_TEXT_NAME: string = 'sunday_offer_timer_text';
    public static TIMER_BG: string = 'sunday_offer_timer_bg';
    public static _name: string;

    private _isVisible: boolean = true;

    /**
     * If true, ignore input; for fixing click-spam issues
     */
    private _throttleClick: boolean = false;

    private timer: SundayOfferTimer;
    private timerTextComponent: UITextComponent;

    public create(params: any): void {
        SundayOfferButton._name = params.name;
        const { buttonCacheKey } = IAPHelper.getWeeklySundayOfferData();
        super.create({
            name: params.name,
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
                scale: [1, 1],
                ...params.layout,
            },
            children: [
                {
                    name: SundayOfferButton.BUTTON_NAME,
                    layout: {
                        anchors: [0.5, 0.5, 0.5, 0.5],
                        pivot: [0.5, 0.5],
                        offsets: [0, 0, 0, 0],
                        scale: [0.9, 0.9],
                    },
                    components: [
                        {
                            type: 'input',
                            data: {
                                enabled: true,
                                buttonMode: true,
                                toggleable: true,
                                tintOnDisable: true,
                            },
                        },
                        {
                            type: 'image',
                            data: {
                                cacheKey: buttonCacheKey,
                            },
                        },
                    ],
                    children: [
                        {
                            name: SundayOfferButton.TIMER_BG,
                            layout: {
                                anchors: [0.5, 0.98, 0.5, 0.98],
                                pivot: [0.5, 0.5],
                                offsets: [0, -7, 0, -7],
                                scale: [1, 1],
                            },
                            components: [
                                {
                                    type: 'image',
                                    data: {
                                        cacheKey: 'offer_icon_timer',
                                    },
                                },
                            ],
                            children: [
                                {
                                    name: SundayOfferButton.TIMER_TEXT_NAME,
                                    layout: {
                                        anchors: [0.62, 0.45, 0.62, 0.45],
                                        pivot: [0.5, 0.5],
                                        offsets: [0, 0, 0, 0],
                                        scale: [1, 1],
                                    },
                                    components: [
                                        {
                                            type: 'text',
                                            data: {
                                                text: '99:99:99',
                                                style: 'sundayOffer.timer',
                                            },
                                        },
                                    ],
                                    children: [],
                                },
                            ],
                        },
                    ],
                },
            ],
            ...params,
        });
        this.addComponent(AnimationComponent);

        const button: GameObject = this.button;
        button.addComponent(ButtonComponent, {
            toggleable: true,
        });
        button.on(GameObjectEvent.SELECTED, this.onSelect.bind(this));
        applyDefaultButtonAnimation(button);

        this.timer = new SundayOfferTimer();
        this.timer.onUpdate = this.updateTimerText.bind(this);
        this.timer.onUpdate();
        this.timer.onComplete = this.handleSundayEnd.bind(this);
        this.timerTextComponent = this.text.getComponent(UITextComponent);

        this.addComponent(StateComponent, {
            handleStateChanged: (state: IGameState) => {
                if ((this._isVisible = IAPStateHelper.isSundayOfferAvailable(state))) {
                    this.show();
                } else {
                    this.hide();
                }
            },
        });
    }

    private onSelect(): void {
        if (this._throttleClick) return;
        this._throttleClick = true;
        UIActions.showPopup(PopupID.SUNDAY_OFFER_MENU, {
            sundayOfferButton: this,
        });
        setTimeout(() => (this ? (this._throttleClick = false) : void 0), 700);
    }
    private readonly updateTimerText = (state: IGameState = Game.store.getState()) => {
        if (this.timerTextComponent && this.timerTextComponent.container && this.timer?.getDate(state)) {
            this.timerTextComponent.text = this.timer.getFormattedCountdown(state);
        }
    };

    private handleSundayEnd(state: IGameState = Game.store.getState()): void {
        if (this.timer === undefined) return;
        if (!this.timer.isCompleted(state)) {
            this.show();
        } else {
            this.hide();
        }
    }

    public show(): void {
        const button: GameObject = this.button;
        button.getComponent(Renderable).visible = true;
        button.on(GameObjectEvent.SELECTED, this.onSelect.bind(this));
    }

    public hide(): void {
        const button: GameObject = this.button;
        button.getComponent(Renderable).visible = false;
        button.off(GameObjectEvent.SELECTED);
        this.timer.stop();
    }

    public get button(): GameObject {
        try {
            return this.findChildByName(SundayOfferButton.BUTTON_NAME);
        } catch (e) {
            console.warn(`${this.name}'s 'button' could not be found`);
        }
    }
    public get text(): GameObject {
        try {
            return this.findChildByName(SundayOfferButton.TIMER_TEXT_NAME);
        } catch (e) {
            console.warn(`${this.name}'s 'text' could not be found`);
        }
    }
}
